export const DEFAULT_LANG = 'en'

export const LOCALES = ['en']
export const LOCKED_PERSONAL_AREA = process.env.NEXT_PUBLIC_LOCKED_PERSONAL_AREA

export const PERSONAL_AREA_NAME = 'mycompetition'
export const PROTECTED_ROUTES = [`/${PERSONAL_AREA_NAME}`, '/apply']

const AUTH_PREFIX = '/auth'

export const AUTH_ROUTES = {
  prefix: AUTH_PREFIX,
  login: `${AUTH_PREFIX}/login`,
  logout: `${AUTH_PREFIX}/logout`,
}

// Important!!
// To be updated when new API routes
// are added or removed on BE side
const API_PREFIX = '/api'

export const API_ROUTES = {
  prefix: API_PREFIX,
  user: `${API_PREFIX}/user`,
  me: `${API_PREFIX}/user/me`,
  applications: `${API_PREFIX}/user/me/applications`,
  draft: `${API_PREFIX}/user/me/application/draft`,
  notifications: `${API_PREFIX}/user/me/notifications`,
  notificationsUnread: `${API_PREFIX}/user/me/notifications/unread`,
  notificationsRead: `${API_PREFIX}/user/me/notifications/read`,
  saveNewApplication: `${API_PREFIX}/user/me/application/save`,
  saveApplication: `${API_PREFIX}/user/me/application/{applicationId}/save`,
  getCurrentApplication: `${API_PREFIX}/user/me/application/{applicationId}`,
  getValidOpportunity: `${API_PREFIX}/user/me/opportunity/unlinked/{competitionId}`,
  getCompetition: `${API_PREFIX}/competition/{slug}`,
}

export const EXTERNAL_API_ROUTES = {
  homepage: '/homepage',
  competitions: '/competitions',
}

export const ShareLinks = {
  facebook:
    'https://www.facebook.com/sharer/sharer.php?description=Take%20a%20look%20at%20this%20competition%20by%20NABA&u=',
  x: 'https://twitter.com/intent/tweet?text=Take%20a%20look%20at%20this%20competition%20by%20NABA&url=',
  telegram:
    'https://t.me/share/url?text=Take%20a%20look%20at%20this%20competition%20by%20NABA&url=',
  linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=',
  email:
    'mailto:?subject=NABA%20Competition&body=Take%20a%20look%20at%20this%20competition%20by%20NABA%20%20',
} as const

export const NABADOMAIN = 'https://www.naba.it' as const

export const DEFAULT_METADATA = {
  title:
    ' NABA International Competitions | Scholarships in Milan, Rome & London',
}

export const TMP_COMPETITIONS = [
  {
    locale: 'en',
    id: 1,
    slug: 'international-scholarship-competition-undergraduate',
  },
  {
    locale: 'en',
    id: 1,
    slug: 'international-scholarship-competition-postgraduate',
  },
]

export const APPLY_LINK_SOURCE = {
  competition: 'Click Apply Now Competition Hero',
  competitionSidebar: 'Click Apply Now Competition Bottom',
  cardList: 'Click Apply Home',
}
